import { NativeModules } from 'react-native';
import type { Errors } from '../native/ZoomVideoSdk';

const { RNZoomVideoSdkLiveStreamHelper } = NativeModules;

/**
 * A class to operate the live stream.
 */
export type ZoomVideoSdkLiveStreamHelperType = {
  /**
   * Check to see if you can start live streaming.
   */
  canStartLiveStream: () => Promise<Errors>;

  /**
   * Start live streaming.
   */
  startLiveStream: (
    streamUrl: string,
    streamKey: string,
    broadcastUrl: string
  ) => Promise<Errors>;

  /**
   * Set to stop live streaming.
   */
  stopLiveStream: () => Promise<Errors>;
};

export class ZoomVideoSdkLiveStreamHelper
  implements ZoomVideoSdkLiveStreamHelperType
{
  async canStartLiveStream() {
    return await RNZoomVideoSdkLiveStreamHelper.canStartLiveStream();
  }

  async startLiveStream(
    streamUrl: string,
    streamKey: string,
    broadcastUrl: string
  ) {
    return await RNZoomVideoSdkLiveStreamHelper.startLiveStream(
      streamUrl,
      streamKey,
      broadcastUrl
    );
  }

  async stopLiveStream() {
    return await RNZoomVideoSdkLiveStreamHelper.stopLiveStream();
  }
}
